import initialSate from './NotificationInitialState';
import reducers from './NotificationReducer';

export default {
  initialSate,
  reducers,
};
